// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"07438606","510":"858d4be6","897":"df388c70","900":"ef0900ad"}[chunkId] + ".chunk.js";
};